import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Button, ButtonProps } from 'primereact/button'

import { useToastContext } from '../../contexts/toast'
import { requestAttachmentDownload } from '../../data/attachments/api'
import { getHandleableError } from '../../utils/errors/isXiaError'

type Props = {
  fullUrl: string
  mimeType: string
  fileName: string
} & ButtonProps

export const AttachmentDownloadButton: React.FC<Props> = ({
  fullUrl,
  mimeType,
  fileName,
  ...props
}) => {
  const { t } = useTranslation('attachment')
  const { replaceToast } = useToastContext()
  const [isRequestRunning, setIsRequestRunning] = useState<boolean>(false)

  const handleOnClick = async (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    setIsRequestRunning(true)
    try {
      const attachmentBlob = await requestAttachmentDownload(
        fullUrl,
        mimeType,
        fileName,
      )

      const fileURL = window.URL.createObjectURL(attachmentBlob)
      const fileLink = document.createElement('a')
      fileLink.href = fileURL
      fileLink.setAttribute('download', fileName)
      document.body.appendChild(fileLink)
      fileLink.click()
      document.body.removeChild(fileLink)
    } catch (error) {
      let handleableError = getHandleableError(error)
      let errorMessage = handleableError.message

      replaceToast({
        style: {},
        closable: true,
        severity: 'error',
        sticky: true,
        detail: errorMessage,
        summary: t('download.messages.error.summary', { name: fileName }),
      })
    } finally {
      setIsRequestRunning(false)
    }
  }

  return (
    <>
      <Button
        aria-label={t('download.label')}
        icon={'pi pi-download'}
        onClick={handleOnClick}
        loading={isRequestRunning}
        rounded
        text
        {...props}
      />
    </>
  )
}
